

















































import {Component, Prop, Vue} from 'vue-property-decorator';
import {TableEditType} from '@/enums/table';
import DeleteDialog from '@c/DeleteDialog.vue';
import ModulesEditDialog from './ModulesEditDialog.vue';
import {PModuleTableHeader} from '../interfaces';
import {getAllModules} from '@/store/modules/entities/pmodules/pmoduleWithMeasurementsModule';

@Component({
  components: {
    DeleteDialog,
    ModulesEditDialog,
  },
})
export default class Table extends Vue {
  @Prop()
  modules!: string;

  @Prop()
  nodeId!: number;

  @Prop()
  buttonDisabled!: boolean;

  @Prop({required: false, default: false})
  filterModules?: boolean;

  pmodules: any[] = [];

  items: any[] = [];

  model: any = null;

  headers: PModuleTableHeader[] = [
    {
      text: 'Элемент',
      value: 'description',
      sortable: false,
    },
  ];

  get deleteDialog() {
    return this.$refs.deleteDialog as any;
  }

  get editDialog() {
    return this.$refs.editDialog as any;
  }

  get actualHeaders() {
    const actionsSlice = [
      {
        text: 'Действия',
        value: 'actions',
        sortable: false,
        width: 90,
      },
    ];
    return [...this.headers, ...actionsSlice];
  }

  async created() {
    this.pmodules = await getAllModules();
    if (!this.modules) return;
    this.items = JSON.parse(this.modules).map((x: string, index: number) => {
      return {
        index: index,
        guid: x,
        description: this.pmodules.find(t => t.guid == x)?.name,
      };
    });
  }

  add() {
    const index = this.items.length ? this.items[this.items.length - 1].index + 1 : 0;
    this.openEditDialog(TableEditType.Add, {index: index, guid: null, description: null});
  }

  edit(item: any) {
    this.openEditDialog(TableEditType.Edit, item);
  }

  openEditDialog(actionType: TableEditType, item: any) {
    const {type, title} = this.getInitialParams(actionType);
    this.model = {...item};
    const options = {
      type,
      title,
      saveCallback: (data: any) => {
        data.description = this.pmodules.find(t => t.guid == data.guid).name;
        if (actionType == TableEditType.Add) this.items.push({...data});
        else {
          const item = this.items.find(x => x.index == data.index);
          item.guid = data.guid;
          item.description = data.description;
        }
        this.editDialog.$refs.form.reset();
        this.editDialog.close();
        this.$emit('update', JSON.stringify(this.items.map(x => x.guid)));
      },
    };
    this.editDialog.open(this.model, options);
  }

  deleteItem(item: any) {
    this.deleteDialog.open(item, {
      deleteCallback: (item: any) => {
        this.items = this.items.filter((x: any) => x.index != item.index);
        this.deleteDialog.close();
        this.$emit('update', JSON.stringify(this.items.map(x => x.guid)));
      },
    });
  }

  getInitialParams(actionType: TableEditType) {
    let params;
    switch (actionType) {
      case TableEditType.Add:
        params = {
          type: 'add',
          title: 'Создание',
        };
        break;
      case TableEditType.Edit:
        params = {
          type: 'edit',
          title: 'Редактирование',
        };
        break;
    }
    return params;
  }
}
